// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"741":"8ffb27b6","956":"c5ade15a"}[chunkId] + ".js";
};